import {sidebarOptionsType} from './_models'
import {useIntl} from 'react-intl'

export enum StakeholderModuleTypes {
  SHAREHOLDER = 'shareholder',
  SHARE_TRANSACTION = 'shareTransaction',
  CONVERTIBLE_TRANSACTION = 'convertibleTransaction',
  WARRANT_TRANSACTION = 'warrantTransaction',
  BUYBACK_TRANSACTION = 'buybackTransaction',
  TRANSFER_TRANSACTION = 'transfterTransaction',
  SHARE_SECURITY_CLASSES = 'shareSecurityClasses',
  CONVERTIBLE_SECURITY_CLASSES = 'convertibleSecurityClasses',
  WARRANT_SECURITY_CLASSES = 'warrantSecurityClasses',
  BOARD_MEMBERS = 'boardMembers',
  FOUNDERS_PROMOTERS = 'foundersPromoters',
  MANAGEMENT_TEAM = 'managementTeam',
  LEGAL_COMPLIANCE = 'legalCompliance',
  FINANCES_ACCOUNTS = 'financesAccounts',
  ADVISORS_MENTORS = 'advisorsMentors',
  COMPLIANCE_MEETING = 'complianceMeeting',
}

export const designationOptions = [
  {
    id: 1,
    name: 'CEO',
    value: 'CEO',
  },
  {
    id: 2,
    name: 'CXO',
    value: 'CXO',
  },
  {
    id: 3,
    name: 'CTO',
    value: 'CTO',
  },
  {
    id: 4,
    name: 'CFO',
    value: 'CFO',
  },
  {
    id: 5,
    name: 'COO',
    value: 'COO',
  },
  {
    id: 6,
    name: 'Cofounder',
    value: 'Cofounder',
  },
  {
    id: 7,
    name: 'Founder',
    value: 'Founder',
  },
  {
    id: 8,
    name: 'Charter Accountant - CA',
    value: 'Charter Accountant - CA',
  },
  {
    id: 9,
    name: 'Company Secretary - CS',
    value: 'Company Secretary - CS',
  },
  {
    id: 10,
    name: 'Accountant',
    value: 'Accountant',
  },
  {
    id: 11,
    name: 'Director',
    value: 'Director',
  },
  {
    id: 12,
    name: 'Investment Banker',
    value: 'Investment Banker',
  },
  {
    id: 13,
    name: 'Lawyer',
    value: 'Lawyer',
  },
  {
    id: 14,
    name: 'Others',
    value: 'Others',
  },
]

export const industryOptions = [
  {
    id: 1,
    name: 'Agriculture',
    value: 'Agriculture',
  },
  {
    id: 2,
    name: 'Advertising',
    value: 'Advertising',
  },
  {
    id: 3,
    name: 'AdultTech',
    value: 'AdultTech',
  },
  {
    id: 4,
    name: 'AI/ML',
    value: 'AI/ML',
  },
  {
    id: 5,
    name: 'AR/VR',
    value: 'AR/VR',
  },
  {
    id: 6,
    name: 'Biotech',
    value: 'Biotech',
  },
  {
    id: 7,
    name: 'Blockchain',
    value: 'Blockchain',
  },
  {
    id: 8,
    name: 'Crypto',
    value: 'Crypto',
  },
  {
    id: 9,
    name: 'Clothing and Apparel',
    value: 'Clothing and Apparel',
  },
  {
    id: 10,
    name: 'Consumer',
    value: 'Consumer',
  },
  {
    id: 11,
    name: 'Consumer Internet',
    value: 'Consumer Internet',
  },
  {
    id: 12,
    name: 'Cyber Security',
    value: 'Cyber Security',
  },
  {
    id: 13,
    name: 'Defence Tech',
    value: 'Defence Tech',
  },
  {
    id: 14,
    name: 'Drone',
    value: 'Drone',
  },
  {
    id: 15,
    name: 'Digital Entertainment',
    value: 'Digital Entertainment',
  },
  {
    id: 16,
    name: 'E-Commerce',
    value: 'E-Commerce',
  },
  {
    id: 17,
    name: 'EdTech',
    value: 'EdTech',
  },
  {
    id: 18,
    name: 'Energy',
    value: 'Energy',
  },
  {
    id: 19,
    name: 'Events',
    value: 'Events',
  },
  {
    id: 20,
    name: 'Financial Services',
    value: 'Financial Services',
  },
  {
    id: 21,
    name: 'FinTech',
    value: 'FinTech',
  },
  {
    id: 22,
    name: 'FMCG',
    value: 'FMCG',
  },
  {
    id: 23,
    name: 'FoodTech',
    value: 'FoodTech',
  },
  {
    id: 24,
    name: 'Gaming',
    value: 'Gaming',
  },
  {
    id: 25,
    name: 'Healthcare',
    value: 'Healthcare',
  },
  {
    id: 26,
    name: 'Information Technology',
    value: 'Information Technology',
  },
  {
    id: 27,
    name: 'IOT',
    value: 'IOT',
  },
  {
    id: 28,
    name: 'Marketplace',
    value: 'Marketplace',
  },
  {
    id: 29,
    name: 'Martech',
    value: 'Martech',
  },
  {
    id: 30,
    name: 'Media And Entertainment',
    value: 'Media And Entertainment',
  },
  {
    id: 31,
    name: 'Mobility & Transport',
    value: 'Mobility & Transport',
  },
  {
    id: 32,
    name: 'Payment',
    value: 'Payment',
  },
  {
    id: 33,
    name: 'Real Estate',
    value: 'Real Estate',
  },
  {
    id: 34,
    name: 'SaaS',
    value: 'SaaS',
  },
  {
    id: 35,
    name: 'Solar & Green Energy',
    value: 'Solar & Green Energy',
  },
  {
    id: 36,
    name: 'Sports & eSports',
    value: 'Sports & eSports',
  },
  {
    id: 37,
    name: 'Transportation',
    value: 'Transportation',
  },
  {
    id: 38,
    name: 'Travel And Tourism',
    value: 'Travel And Tourism',
  },
  {
    id: 39,
    name: 'Wearable',
    value: 'Wearable',
  },
  {
    id: 40,
    name: 'Other',
    value: 'Other',
  },
]

export const InvestorSidebarOptions = () => {
  const intl = useIntl()
  const investorSidebarOptions: sidebarOptionsType[] = [
    {
      id: 2,
      title: intl.formatMessage({id: 'Upcoming'}),
      slug: '/investor-crm/investor/activities/upcoming',
    },
    {
      id: 3,
      title: intl.formatMessage({id: 'Past'}),
      slug: '/investor-crm/investor/activities/past',
    },
    {
      id: 1,
      title: intl.formatMessage({id: 'All'}),
      slug: '/investor-crm/investor/activities/all',
    },
  ]
  const updateSidebarOptions: sidebarOptionsType[] = [
    {
      id: 1,
      title: intl.formatMessage({id: 'All'}),
      slug: '/investor-crm/investor/update/all',
    },
    {
      id: 2,
      title: intl.formatMessage({id: 'Internal'}),
      slug: '/investor-crm/investor/update/internal',
    },
    {
      id: 3,
      title: intl.formatMessage({id: 'External'}),
      slug: '/investor-crm/investor/update/external',
    },
  ]
  return {
    investorSidebarOptions,
    updateSidebarOptions,
  }
}

export const roundInitialValues = {
  roundName: '',
  amountTargeted: '',
  roundType: '',
  currency: '0',
  amountAchieved: '',
}

export const roleValues = {
  OWNER: 'owner',
  // ADMIN: 'admin',
  // CURATOR: 'curator',
  // FRM: 'frm',
  // IRM: 'irm',
  // BILLING: 'billing',
}

export const entitlement_Feature = {
  Email: 'email',
  DataImport: 'data-import',
  InvestorUpdates: 'investor-updates',
  BCCTracking: 'bcc-tracking',
  CompanyPage: 'company-page',
  TeamMember: 'team-member',
  InvestorDatabase: 'investor-database',
  InvestorsCount: 'investors-count',
  DataRooms: 'data-rooms',
}

export const allowedFileTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  'application/vnd.ms-powerpoint',
  'application/rtf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.apple.keynote',
  'text/html',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.presentation',
  'text/markdown',
  'image/*',
  'video/*',
  'audio/*',
  'text/csv',
]

export const viewableFileTypes = [
  'jpg',
  'jpeg',
  'png',
  'svg',
  'webp',
  'ppt',
  'pptx',
  'docx',
  'doc',
  'xlsx',
  'xls',
  'mp4',
  'mov',
  'avi',
  'wmv',
  'flv',
  'webm',
  'mkv',
  'mp3',
  'wav',
  'flac',
  'aac',
  'wma',
  'm4a',
  'ogg',
  'aiff',
  'midi',
  'pdf',
  'csv',
  'mp4a',
  'm4a'
]

export const supportedFileExtensions = [
  'text',
  'txt',
  'text',
  'rtf',
  'png',
  'jpg',
  'jpeg',
  'gif',
  'webp',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'note',
  'html',
  'pdf',
  'ppt',
  'pptx',
  'odt',
  'ods',
  'odp',
  'md',
  'csv',
  'svg',
  'tiff',
  'tif',
  'mp4',
  'ogg',
  'mp3',
  'wav',
  'avi',
  'mov',
  'flv',
  'wmv',
  'mkv',
]

export const periodOptions=[
  {
    id: 1,
    name: 'Days',
    value: 'Days',
  },
  {
    id: 2,
    name: 'Months',
    value: 'Months',
  },
  {
    id: 3,
    name: 'Years',
    value: 'Years',
  },
]

export const allowedRecordTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.presentation',
  'image/*',
]
